"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootCause = exports.CreditReason = void 0;
var CreditReason;
(function (CreditReason) {
    CreditReason["SFP_SHIPPING"] = "SFP_SHIPPING";
    CreditReason["STORAGE_PROMO"] = "STORAGE_PROMO";
    CreditReason["MANUAL_CREDIT"] = "MANUAL_CREDIT";
    CreditReason["INTERNAL_CREDIT"] = "INTERNAL_CREDIT";
})(CreditReason || (exports.CreditReason = CreditReason = {}));
var RootCause;
(function (RootCause) {
    RootCause["CHANNEL_INTEGRATION"] = "Channel Integration";
    RootCause["DAMAGE_INBOUND_INVENTORY"] = "Damage (Inbound/Inventory)";
    RootCause["INCORRECT_NON_COMPLIANCE"] = "Incorrect Non-Compliance";
    RootCause["FREIGHT_BILLING"] = "Freight Billing";
    RootCause["PREP"] = "Prep";
    RootCause["FULFILLMENT_INBOUNDS"] = "Fulfillment - Inbounds";
    RootCause["FULFILLMENT_INVENTORY"] = "Fulfillment - Inventory";
    RootCause["RESERVE_STORAGE_INVENTORY"] = "Reserve Storage - Inventory";
    RootCause["LONG_TERM_STORAGE"] = "Long-Term Storage";
    RootCause["REPLENISHMENT_EXTERNAL"] = "Replenishment (External - FBA, WFS, etc)";
    RootCause["REPLENISHMENT_INTERNAL"] = "Replenishment (Internal - Transfer to Ecom)";
    RootCause["INCORRECT_DIMENSIONS_RIGID"] = "Incorrect Dimensions - Rigid";
    RootCause["INCORRECT_DIMENSIONS_NON_RIGID"] = "Incorrect Dimensions - Non-Rigid";
    RootCause["OB_NO_TRACKING_MOVEMENT"] = "OB - No Tracking Movement";
    RootCause["OB_DELIVERED_BUT_LOST"] = "OB - Delivered but lost";
    RootCause["OB_DELIVERED_DAMAGED"] = "OB - Delivered damaged";
    RootCause["OB_MISSING_PRODUCT"] = "OB - Missing product";
    RootCause["OB_INCORRECT_PRODUCT"] = "OB - Incorrect product";
    RootCause["B2B_NO_TRACKING_MOVEMENT"] = "B2B - No Tracking Movement";
    RootCause["B2B_DELIVERED_BUT_LOST"] = "B2B - Delivered but lost";
    RootCause["B2B_DELIVERED_DAMAGED"] = "B2B - Delivered damaged";
    RootCause["B2B_MISSING_PRODUCT"] = "B2B - Missing product";
    RootCause["B2B_INCORRECT_PRODUCT"] = "B2B - Incorrect product";
    RootCause["REMOVALS_DAMAGES"] = "Removals - Damages";
    RootCause["REMOVALS_SHORT_SHIP"] = "Removals - Short ship";
    RootCause["INVOICE_OR_BILLING_DISPUTE"] = "Invoice or Billing Dispute (Including unable to pay invoice)";
    RootCause["OTHER_NON_OPERATIONAL_ISSUE"] = "Other Non-Operational Issue";
})(RootCause || (exports.RootCause = RootCause = {}));
//# sourceMappingURL=Credit.js.map